import { gql } from "@apollo/client";

export const MoveInstalledBaseNode = gql`
    mutation MoveInstalledBaseNode (
        $id: ID!,
        $targetParentNodeId: ID!,
        $removeAttributes: [InstalledBaseEventAttributeInput!],
        $installAttributes: [InstalledBaseEventAttributeInput!]
    ) {
        moveInstalledBaseNode (
            id: $id,
            targetParentNodeId: $targetParentNodeId,
            removeAttributes: $removeAttributes,
            installAttributes: $installAttributes
        ) {
            id
            parentNode {
                id
            }
        }
    }
`;
